import { ACTIVATION_SELECT_ENABLE, ACTIVATION_SELECT_DISABLE, ACTIVATION_DISABLE } from "./ItemMyStatBase"


export class ReqClient {
    constructor({ start=0, limit=10}){
        this.start = start
        this.limit = limit
    }
    fromJson(jsonData) {
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
    }
}

export class RespClient {
    constructor({ team_id = "", team_name = "", activation = ACTIVATION_DISABLE,
        startDate, endDate, actCodeTotal = 0, actCodeCap = 75, admin, activationCode, activationCodeCreatAt }) {
        this.team_id = team_id
        //球隊名稱
        this.team_name = team_name
        //啟停用
        this.activation = activation
        this.startDate = startDate
        this.endDate = endDate
        //使用人數
        this.actCodeTotal = actCodeTotal
        //使用人數上限
        this.actCodeCap = actCodeCap
        //管理員帳號
        this.admin = admin
        //啟動碼
        this.activationCode = activationCode
        //啟動碼產生時間
        this.activationCodeCreatAt = activationCodeCreatAt
    }

    fromJson(jsonData) {
        this.team_id = jsonData.team_id || ""
        this.team_name = jsonData.team_name || ""
        this.activation = jsonData.activation || ACTIVATION_DISABLE
        this.startDate = jsonData.startDate || ""
        this.endDate = jsonData.endDate || ""
        this.actCodeTotal = jsonData.actCodeTotal || 0
        this.actCodeCap = jsonData.actCodeCap || 75
        this.admin = jsonData.admin || ""
        this.activationCode = jsonData.activationCode
    }

    get_team_activation() {
        return this.activation === 1 ? true : false
    }
}
